export const supportedLanguages = ["hu", "en", "de"] as const;
